module.exports = __webpack_public_path__ + "static/media/ic_createDomain.58a25dd2.png";